export default __webpack_public_path__ + "static/media/screenshot_app_skills_desktop_purple.b412f2f7.png";